<template>
  <header class="op-header">
    <section class="header__content">
      <section class="content-left">
        <router-link to="/" class="flex flex-align-center">
          <img class="logo-img" src="@/assets/images/logo.png" />
          <div class="content-logo">宝尊开放平台</div>
        </router-link>

        <op-nav></op-nav>
      </section>

      <div class="content-right">
        <div class="user-name" v-if="this.userName">
          <a href="/control"
            >{{ this.userName }} <Icon type="ios-arrow-down"
          /></a>
          <ul class="sub-nav">
            <li class="login-out" @click="handleLogOout">退出登录</li>
          </ul>
        </div>
        <div class="button-text" v-else><a href="/control/login">登录</a></div>
        <!-- <div class="button-border">注册</div> -->
      </div>
    </section>
  </header>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import opNav from "@/components/common/nav.vue";
export default {
  data() {
    return {
      userName: null
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.userName = localStorage.getItem("openApiConsoleAccount");
    this.indexHome();
  },
  watch: {},
  methods: {
    ...mapActions({
      loginOut: "home/loginOut",
      indexHome: "home/indexHome"
    }),
    async handleLogOout() {
      await this.loginOut();
      localStorage.clear();
      this.$router.go();
    }
  },
  components: { opNav }
};
</script>

<style lang="less">
.op-header {
  background: @color-info;
  position: relative;
  z-index: 1;

  .header__content {
    width: 1200px;
    height: 56px;
    margin: 0px auto;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-left {
      height: 100%;
      display: flex;
      align-items: center;
      .logo-img {
        width: 36px;
        margin-right: 16px;
      }
      .content-logo {
        font-size: 20px;
        color: @color-font-white;
        cursor: pointer;
      }
      p {
        color: @color-font-label;
      }
    }

    .content-right {
      color: @color-font-label;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .button-text {
        margin-right: 32px;
        cursor: pointer;
        &:hover {
          color: @color-font-white;
        }
      }
      p {
        color: @color-font-label;
      }
      .user-name {
        cursor: pointer;
        position: relative;
        width: 150px;
        text-align: right;
        a {
          line-height: 56px;
          display: inline-block;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
        }

        .sub-nav {
          margin-top: -2px;
          width: 172px;
          position: absolute;
          top: 100%;
          left: 0px;
          line-height: 40px;
          background: @color-default;
          opacity: 0;
          pointer-events: none;
          transition: all 0.3s;
          li {
            color: @color-font-label;
            padding: 0px 16px;
            transition: all 0.3s;
            background: #3b3f51;
            text-align: left;
            &.active {
              background: @color-info;
              color: @color-font-white;
              padding-left: 26px;
              transition: all 0.3s;
            }
            &:hover {
              background: @color-info;
              color: @color-font-white;
            }
            a {
              justify-content: flex-start;
            }
          }
        }
        &:hover .sub-nav {
          opacity: 1;
          pointer-events: auto;
          transition: all 0.3s;
        }
      }
      .button-border {
        border: 2px solid @color-font-label;
        border-radius: 2px;
        height: 32px;
        padding: 0px 32px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          color: @color-font-white;
          border: 2px solid @color-font-white;
        }
      }
    }
  }
}
</style>
